import qs from 'qs'

export interface UriComponents {
  uri: string
  basePath: string
  pathParts: string[]
  query: {
    rawQueryString: string
    params?: qs.ParsedQs
  }
}
export const getUriComponents = (path: string): UriComponents => {
  //always start the path with root (/)
  const adjustedPath = path.startsWith('/') ? path.substring(1) : path
  const uriParts = adjustedPath.split('?')
  const uri = uriParts[0]
  const rawQueryString = uriParts.length > 1 ? uriParts[1] : ''
  const pathParts = uri.split('/')
  const basePath = `/${pathParts[0] ?? ''}`
  return {
    uri,
    basePath,
    pathParts,
    query: {
      rawQueryString,
      params:
        rawQueryString === ''
          ? undefined
          : qs.parse(rawQueryString, {
              ignoreQueryPrefix: true,
            }),
    },
  }
}
